//  index.js
//  Project hpi
//
//  Created by Axis Maps on 6/15/2020, 10:52:37 AM
//

import Loadable from 'react-loadable';

export default Loadable({
  loader: () => import('./compare-indicators.component'),
  loading: () => null,
});
